import { gql } from '@apollo/client'

export const DENY_GROUP_CLEARANCE_STATUS = gql`
  mutation DenyGroupClearanceStatus($inputData: DenyGroupClearanceStatusInput!) {
    denyGroupClearanceStatus(inputData: $inputData)
  }
`
